import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "group flex relative h-fit" }
const _hoisted_2 = { class: "group-hover:block -translate-x-1/2 translate-y-full hidden z-[9] absolute -bottom-5 xs:left-2 sm:left-32 xs:min-w-fit xs:w-32 sm:w-[261px] drop-shadow-lg rounded-[10px] transition-opacity bg-white border border-gray-200 p-4" }
const _hoisted_3 = { class: "text-gray-800 text-sm font-semibold font-inter pb-2" }
const _hoisted_4 = { class: "text-gray-800 font-normal text-sm font-inter" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
  heading: {
    type: String,
    default: "Heading",
  },
  text: {
    type: String,
    default: "",
  },
},
  setup(__props) {

// Props
const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_snap_icon = _resolveComponent("snap-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_snap_icon, {
      icon: "information-circle-solid",
      color: "#3B82F6",
      size: "xs",
      state: "default",
      class: "ml-2 pointer"
    }),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-4 h-4 border-l border-t border-gray-200 -mb-[7px] rotate-45 absolute bottom-full bg-white shadow-current xs:mx-14 sm:mx-auto" }, null, -1)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.heading), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(props.text), 1)
    ])
  ]))
}
}

})